import type { NDateLocale } from './enUS'
import { hu } from 'date-fns/locale'

const dateHuHU: NDateLocale = {
  name: 'hu-HU',
  locale: hu
}

export default dateHuHU
